import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchRepositorySettings } from "./api";
import type { RepositorySettingsResponse } from "./api";

// Настройки для введённого `owner/repo`. Запрос отключён без введённого
// репо (пустую строку на сервер не шлём). Паттерн `useRepoTemplate`.
export function useRepositorySettings(
  repoFullName: string,
): UseQueryResult<RepositorySettingsResponse, Error> {
  return useOrgScopedQuery<RepositorySettingsResponse>({
    key: ["repositorySettings", repoFullName],
    queryFn: () => fetchRepositorySettings(repoFullName),
    enabled: repoFullName.length > 0,
    retry: false,
  });
}
